import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { IconThemeReverseModule } from '../../../../shared';
import { CatalogFilterResetModule } from '../catalog-filter-reset/catalog-filter-reset.module';
import { CatalogFilterBreadcrumbsComponent } from './catalog-filter-breadcrumbs.component';

@NgModule({
  declarations: [CatalogFilterBreadcrumbsComponent],
  exports: [CatalogFilterBreadcrumbsComponent],
  imports: [CommonModule, NzIconModule, I18nModule, CatalogFilterResetModule, IconThemeReverseModule],
})
export class CatalogFilterBreadcrumbsModule {}
